/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { tokens } from '@neo4j-ndl/base';
import { Combobox, GraphLabel } from '@neo4j-ndl/react';
import { useState } from 'react';

// The option type is free to carry fields of its own. Passing these options to
// the combobox is what types `option` inside the overrides below.
type NodeLabelOption = {
  label: string;
  value: string;
  color: string;
};

const options: NodeLabelOption[] = [
  { color: tokens.graph['1'], label: 'Person', value: 'person' },
  { color: tokens.graph['2'], label: 'Movie', value: 'movie' },
  { color: tokens.graph['3'], label: 'Director', value: 'director' },
  { color: tokens.graph['4'], label: 'Actor', value: 'actor' },
  { color: tokens.graph['7'], label: 'Genre', value: 'genre' },
  { color: tokens.graph['12'], label: 'Studio', value: 'studio' },
];

// One presentation for the selected values and for the options, so both read
// the same. `as="span"` keeps it non-interactive, which leaves the list and the
// clear button as the ways to deselect.
const NodeLabel = ({
  option,
  isDisabled,
}: {
  option: NodeLabelOption;
  isDisabled: boolean;
}) => (
  <GraphLabel
    as="span"
    type="node"
    size="small"
    color={option.color}
    isDisabled={isDisabled}
  >
    {option.label}
  </GraphLabel>
);

const Component = () => {
  const [value, setValue] = useState<NodeLabelOption[]>(options.slice(0, 2));

  return (
    <Combobox
      label="Node labels"
      helpText="Deselect a label in the list to remove it."
      isMulti
      isClearable
      options={options}
      value={value}
      onChange={setValue}
      components={{ MultiValue: NodeLabel, OptionLabel: NodeLabel }}
    />
  );
};

export default Component;
